import * as React from 'react';
import { Block, Icon, Text } from '../../../../../../../components';
import checkIcon from '../../../../../../../../assets/icons/icon-check-white.svg';

const Step = (props: any) => {
  const {
    isFirst,
    name,
    order,
    date,
    isLast,
    children,
    disabled,
    // isCurrent,
    isComplete
  } = props;
  return (
    <Block customized className="step">
      <Block
        customized
        className="heading"
        flexDirection="row"
        alignItems="center"
      >
        <Block
          customized
          backgroundColor={isComplete ? '#5B36F2' : 'none'}
          //   border="2px solid #5B36F2"
          border={disabled ? '2px solid #8090BB' : '2px solid #5B36F2'}
          borderRadius="100%"
          maxWidth="32px"
          height="32px"
          alignItems="center"
          justifyContent="center"
          margin="0px 8px 0px 0px"
        >
          {!isComplete && (
            <Text
              fontWeight="700"
              fontSize="14px"
              lineHeight="20px"
              color={disabled ? '#8090BB' : '#5B36F2'}
            >
              {order}
            </Text>
          )}
          {isComplete && (
            <Icon customized alignItems="center" maxWidth="15px">
              <img src={checkIcon} alt="chevron" />
            </Icon>
          )}
        </Block>
        <Block
          customized
          padding={date && !isFirst ? '14px 0px 0px 0px' : '0px'}
        >
          <Text
            fontWeight="700"
            fontSize="14px"
            lineHeight="20px"
            color={disabled ? '#8090BB' : '#5B36F2'}
          >
            {name}
          </Text>
          {date && !isFirst && (
            <Text fontWeight="500" fontSize="12px" lineHeight="16px">
              {date}
            </Text>
          )}
        </Block>
      </Block>
      <Block
        customized
        className="content"
        flexDirection="row"
        alignItems="flex-start"
        margin="4px 0px 4px 0px"
        minHeight="20px"
        style={{ position: 'relative' }}
      >
        {!isLast && (
          <Block
            customized
            style={{ position: 'absolute' }}
            className="line"
            height="100%"
            alignItems="center"
            justifyContent="center"
            margin="0px 8px 0px 16px"
            maxWidth="2px"
          >
            <Block
              customized
              backgroundColor={!isComplete ? '#8090BB' : '#5B36F2'}
              height="100%"
              // minHeight="32px"
              maxWidth="2px"
            />
          </Block>
        )}
        <Block
          customized
          className="card"
          margin="0px 0px 0px 40px"
          // aqui debemos cambiar
          maxWidth="100%"
        >
          <div
            style={{
              width: '100%',
              color: disabled
                ? 'var(--primary-disable-text)'
                : 'var(--text-text02)'
            }}
          >
            {children}
          </div>
        </Block>
      </Block>
    </Block>
  );
};

export default Step;
